import { Modal as ModalAntd } from 'antd';
import styled from 'styled-components';

export const Modal = styled(ModalAntd)`
  display: flex;
  width: 100%;
  padding: 1.5rem;
  flex-direction: column;
  align-items: flex-end;
  gap: 1rem;
  .ant-modal-header {
    display: flex;
    gap: 1rem;
    width: 100%;
    border-bottom: none;
    padding-bottom: 0px;
    padding-top: 16px;
    background: transparent !important;
  }

  .ant-modal-title span {
    display: flex;
    gap: 0.5rem;
    width: 100%;
    align-items: center;
  }

  .ant-modal-body {
    display: flex;
    justify-content: left;
    align-items: center;
    padding-left: 2.9rem;
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    width: 100%;
    /* identical to box height, or 150% */
    background: #fff;
    color: rgba(0, 0, 0, 0.85);

    /* Inside auto layout */

    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;
  }

  .ant-modal-footer {
    padding: 16px 24px;
    width: 100%;
    display: flex;
    gap: 1rem;
    justify-content: right;
    border-top: none;
  }
`;

export default {
  Modal
};
